import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { SeoServiceService } from "@xref/ngx";

import { PendingVerificationModule } from "../../components/pending-verification/pending-verification.module";
import { LoginAppsModule } from "./components/login-apps/login-apps.module";
import { LoginFormModule } from "./components/login-form/login-form.module";
import { LoginComponent } from "./login.component";

@NgModule({
    imports: [
        CommonModule,
        LoginFormModule,
        LoginAppsModule,
        PendingVerificationModule,
    ],
    declarations: [LoginComponent],
    providers: [SeoServiceService],
})
export class LoginModule {}
